/* eslint-env browser */

import * as React from 'react'

require('../../container/client')

const ReactDOM = require('react-dom')
const DomHelper = require('../../client/clientjs/dom-helper')
const FullCatch = require('../../client/clientjs/components/Catches/FullCatch')

DomHelper.onDocumentReady(() => {
  const renderFullCatch = DomHelper.query('#react-render-fish-catch')
  if (renderFullCatch) {
    ReactDOM.hydrate(
      <FullCatch
        locale={window.initialState.locale.identifierShort}
        fishCatch={window.initialState.fishCatch}
        locationLabels={window.initialState.locationLabels}
        isLoggedIn={window.initialState.isLoggedIn}
        userSettings={window.initialState.userSettings}
        latestComments={window.initialState.latestComments}
        commentsCount={window.initialState.commentsCount}
        currentUserLike={window.initialState.currentUserLike}
        otherCatches={window.initialState.otherCatches}
        inContests={window.initialState.inContests}
        host={window.initialState.config.host}
      />,
      renderFullCatch
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
